/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { ResourceUtilizationChart } from './ServerInventory/ResourceUtilizationChart';

export type NodeDetailsServerInventoryProps = {
  nodeId: string;
};

export function NodeDetailsServerInventory({ nodeId }: NodeDetailsServerInventoryProps) {
  return (
    <div data-testid="node-details-server-inventory">
      <ResourceUtilizationChart nodeId={nodeId} />
    </div>
  );
}
